<template>
  <main class="login-layout">
    <form
      class="form-entrar"
      @submit.prevent="submitForm"
    >
      <nav
        class="btn-voltar"
        aria-label="Navegação de retorno"
      >
        <router-link to="/login">Voltar</router-link>
      </nav>

      <h1>Cadastro GEX</h1>

      <div
        v-if="!emailEnviado"
        class="form-etapa"
      >
        <div class="input-group-container">
          <label for="name">Nome Completo:</label>
          <input
            type="text"
            id="name"
            placeholder="Digite seu Nome Completo"
            class="input-login"
            v-model="formData.usuario.nome"
            required
          />
        </div>

        <div class="input-group-container">
          <label for="email">E-mail:</label>
          <input
            type="email"
            id="email"
            placeholder="Digite seu e-mail"
            class="input-login"
            v-model="formData.usuario.email"
            required
          />
        </div>

        <div class="form-cpf">
          <div
            id="radio-estrangeiro"
            role="radiogroup"
            aria-label="Nacionalidade"
          >
            <div class="radio-option">
              <input
                class="form-check-input"
                type="radio"
                id="brasileiro"
                v-model="formData.usuario.estrangeiro"
                :value="false"
              />
              <label
                class="form-check-label"
                for="brasileiro"
              >
                Brasileiro (Brazilian)
              </label>
            </div>
            <div class="radio-option">
              <input
                class="form-check-input"
                type="radio"
                id="estrangeiro"
                v-model="formData.usuario.estrangeiro"
                :value="true"
                @click="formData.usuario.cpf = ''"
              />
              <label
                class="form-check-label"
                for="estrangeiro"
              >
                Estrangeiro (Foreigner)
              </label>
            </div>
          </div>

          <div class="input-group-container">
            <label for="cpf">CPF:</label>
            <input
              type="text"
              id="cpf"
              placeholder="Digite seu CPF"
              class="input-login"
              v-model="formData.usuario.cpf"
              v-maska="'###.###.###-##'"
              :disabled="formData.usuario.estrangeiro"
              :required="!formData.usuario.estrangeiro"
            />
          </div>
        </div>
      </div>

      <div
        v-if="emailEnviado"
        class="form-etapa"
      >
        <div
          id="div-validacao"
          class="card p-2 text-center"
          aria-live="polite"
        >
          <h2>Um código de verificação foi enviado para seu e-mail</h2>

          <div
            id="otp"
            class="inputs d-flex flex-row justify-content-center mt-2"
          >
            <input
              v-for="(digito, index) in 6"
              :key="index"
              :ref="(el) => (inputsRefs[index] = el)"
              class="otp-input m-2 text-center form-control rounded"
              type="text"
              v-model="codigo[index]"
              maxlength="1"
              :aria-label="`Dígito ${index + 1} do código de verificação`"
              @input="avancarFoco(index)"
              @keyup.delete="voltarFoco(index)"
              @paste="colarCodigo"
              v-maska="'#'"
            />
          </div>
        </div>

        <div class="input-group-container mt-3">
          <label for="nova-senha">Senha</label>
          <input
            id="nova-senha"
            class="input-login"
            type="password"
            placeholder="Digite sua senha"
            v-model="senha"
            @keyup="verificarSenha"
            required
          />
        </div>

        <div class="input-group-container">
          <label for="confirmar-nova-senha">Confirmar senha</label>
          <input
            id="confirmar-nova-senha"
            class="input-login"
            type="password"
            placeholder="Confirme sua senha"
            v-model="confirmacaoSenha"
            :disabled="!verificarSenha()"
            required
          />
        </div>

        <div
          class="alertas-senha"
          aria-live="assertive"
        >
          <p
            v-if="senha != confirmacaoSenha"
            class="text-erro"
          >
            As senhas não são iguais
          </p>
          <p
            v-if="senha.length > 0 && (senha.length < 6 || senha.length > 36)"
            class="text-erro"
          >
            A senha deve ter entre 6 e 36 caracteres
          </p>
          <p
            v-if="senha.includes(' ')"
            class="text-erro"
          >
            A senha não pode conter espaços
          </p>
          <p
            v-if="senha.length > 0 && VerificarcaracteresEspeciais(senha)"
            class="text-erro"
          >
            Sua senha deve conter pelo menos um caractere especial
          </p>
        </div>
      </div>

      <button
        type="submit"
        class="submit-login"
        :disabled="carregando || (emailEnviado && !(senha == confirmacaoSenha))"
      >
        {{ carregando ? "Processando..." : "Avançar" }}
      </button>
    </form>
  </main>
</template>

<script>
import { vMaska } from "maska/vue";
import externosService from "@/service/externosService";
import controleDeAcessoService from "@/service/controleDeAcessoService";
import router from "@/router";

export default {
  data() {
    return {
      formData: {
        usuario: {
          nome: "",
          cpf: "",
          email: "",
          estrangeiro: false,
          telefone: "",
          dataNascimento: "",
          genero: null,
          heteroidentificacao: null,
          regra_id: null,
        },
        escolaridade: null,
        rendaFamiliar: null,
      },
      codigo: ["", "", "", "", "", ""],
      inputsRefs: [],
      senha: "",
      confirmacaoSenha: "",
      carregando: false,
      cadastroConcluido: false,
      emailEnviado: false,
      email: "",
    };
  },
  methods: {
    avancarFoco(index) {
      if (this.codigo[index] && index < 5) {
        const proximoInput = this.inputsRefs[index + 1];
        if (proximoInput) {
          proximoInput.focus();
        }
      }
    },
    voltarFoco(index) {
      if (!this.codigo[index] && index > 0) {
        const inputAnterior = this.inputsRefs[index - 1];
        if (inputAnterior) {
          inputAnterior.focus();
        }
      }
    },
    colarCodigo(event) {
      event.preventDefault();
      const textoColado = event.clipboardData.getData("text");
      if (!/^\d+$/.test(textoColado)) return;

      const digitos = textoColado.split("").slice(0, 6);
      digitos.forEach((num, i) => {
        this.codigo[i] = num;
      });

      const ultimoIndice = Math.min(digitos.length, 5);
      this.$nextTick(() => {
        this.inputsRefs[ultimoIndice]?.focus();
      });
    },
    verificarSenha() {
      return (
        this.senha.length >= 6 &&
        this.senha.length <= 36 &&
        !this.VerificarcaracteresEspeciais(this.senha)
      );
    },
    VerificarcaracteresEspeciais(senha) {
      const caracteresEspeciais = /[!@#$%^&*(),.?":{}|<>;]/;
      return !caracteresEspeciais.test(senha);
    },
    async submitForm() {
      this.carregando = true;
      if (!this.cadastroConcluido) {
        if (this.formData.usuario.estrangeiro) {
          this.formData.usuario.cpf = null;
        }
        const response = await externosService.postExterno(this.formData);
        if (response) {
          this.cadastroConcluido = true;
        }
      } else {
        const pincode = this.codigo.join("");
        const cpfSemMascara = this.formData.usuario.cpf
          ? this.formData.usuario.cpf.replace(/\D/g, "")
          : this.formData.usuario.email;

        if (pincode && pincode.length == 6) {
          const data = {
            emailOrCpf: cpfSemMascara,
            pinCode: pincode,
            senha: this.senha,
          };
          const validacao = await controleDeAcessoService.validarPinCode(data);
          if (validacao === 200) {
            alert(
              "Senha criada com sucesso, você já pode fazer seu login no Gex."
            );
            router.push("/login/autenticacao-gex");
          }
        } else {
          alert("Por favor insira o código de verificação válido");
        }
      }
      this.carregando = false;
    },
    async enviarPincode() {
      const cpfSemMascara = this.formData.usuario.cpf
        ? this.formData.usuario.cpf.replace(/\D/g, "")
        : this.formData.usuario.email;
      const response =
        await controleDeAcessoService.gerarPinCode(cpfSemMascara);

      if (response.status === 202) {
        this.emailEnviado = true;
        this.email = response.data.email;
        alert(
          `Um código de confirmação foi enviado para o e-mail: ${this.email}.`
        );
      } else if (
        response.status === 400 &&
        response.data === "Aguarde para nova requisição"
      ) {
        alert(
          "O e-mail já foi enviado recentemente. Aguarde para uma nova requisição."
        );
        this.emailEnviado = true;
      } else {
        this.emailEnviado = true;
      }
    },
  },
  directives: {
    maska: vMaska,
  },
  watch: {
    async cadastroConcluido(newValue) {
      if (newValue) {
        await this.enviarPincode();
      }
    },
  },
  beforeUpdate() {
    this.inputsRefs = [];
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", Avenir, Helvetica, Arial, sans-serif;
}

.login-layout {
  background: linear-gradient(135deg, #7d0c9f 0%, #563578 100%);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.form-entrar {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.4s ease-in-out;
}

.form-etapa {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.input-group-container {
  display: flex;
  flex-direction: column;
}

/* Links em contraste AAA */
a {
  font-weight: bold;
  text-decoration: none;
  color: #4a1d8a;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}
a:hover {
  color: #311b92;
}

/* Título */
.form-entrar h1 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: #4a1d8a;
  text-align: center;
}

#div-validacao h2 {
  font-size: 1rem;
  color: #2d3748;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

/* Botão voltar */
.btn-voltar a {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.8rem;
  background: #713cba;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-voltar a::before {
  content: "←";
  font-size: 0.9rem;
}

.btn-voltar a:hover {
  background: #5e2ea0;
  color: #8f55e0;
}
.btn-voltar a:active {
  background: #4a1d8a;
}
/* Labels */
.form-entrar label {
  font-size: 0.95rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 0.3rem;
  display: block;
}

/* Inputs e áreas de toque do Lighthouse (Mínimo 48px de altura) */
.input-login {
  width: 100%;
  height: 48px;
  padding: 0 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 400;
  color: #000;
  outline: none;
  transition:
    border 0.3s ease,
    box-shadow 0.3s ease;
}
.input-login:focus {
  border-color: #713cba;
  box-shadow: 0 0 0 3px rgba(113, 60, 186, 0.2);
}
.input-login:disabled {
  background-color: #edf2f7;
  cursor: not-allowed;
}

/* Botão Cadastrar */
.submit-login {
  width: 100%;
  height: 48px;
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  background: #713cba;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.submit-login:hover {
  background: #5e2ea0;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(113, 60, 186, 0.3);
}
.submit-login:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Opções de Rádio com espaçamento otimizado */
#radio-estrangeiro {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-bottom: 0.5rem;
}
.radio-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 32px;
}
.form-check-label {
  color: #2d3748;
  cursor: pointer;
}
.form-check-input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Alertas de validação de senha */
.alertas-senha {
  margin-top: 0.5rem;
}
.text-erro {
  color: #e11d48;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
}

/* Caixa OTP */
#otp .otp-input {
  width: 48px;
  height: 48px;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
  background-color: #f7fafc;
  border: 2px solid #cbd5e0;
  border-radius: 8px;
  transition: all 0.25s ease;
}
#otp .otp-input:focus {
  outline: none;
  background-color: #fff;
  border-color: #713cba;
  box-shadow: 0 0 0 3px rgba(113, 60, 186, 0.2);
  transform: scale(1.05);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 500px) {
  .form-entrar {
    padding: 2rem 1.2rem;
  }
  .form-entrar h1 {
    font-size: 1.5rem;
  }
}
</style>
